import { PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CookiesAcceptedService } from './cookies-accepted.service';

declare let gtag: Function;

@Injectable()
export class GoogleAnalyticsService {
    private cookiesAccepted: boolean;

    constructor(public router: Router,
                @Inject(PLATFORM_ID) private platformId: Object,
                private cookiesAcceptedService: CookiesAcceptedService) {
        if (environment.production && isPlatformBrowser(this.platformId)) {
            this.cookiesAcceptedService.acceptCookies$.subscribe(a => {
                if (a) {
                    // Downloads Google Analytics once the page has loaded
                    const googleAnalyticsScript1 = document.createElement('script');
                    googleAnalyticsScript1.setAttribute('async', 'true');
                    googleAnalyticsScript1.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${environment.googleAnalyticsId}`);
                    const googleAnalyticsScript2 = document.createElement('script');
                    googleAnalyticsScript2.innerText = 'window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag(\'js\', new Date());';
                    document.documentElement.firstChild.appendChild(googleAnalyticsScript1);
                    document.documentElement.firstChild.appendChild(googleAnalyticsScript2);
                    // Tracks the pages
                    this.router.events.subscribe((event) => {
                        if (event instanceof NavigationEnd) {
                            gtag('config', environment.googleAnalyticsId, {
                                'page_path': event.urlAfterRedirects
                            });
                        }
                    });
                    // Initial page
                    gtag('config', environment.googleAnalyticsId, {
                        'page_path': router.url
                    });
                }
            });
        }
    }

    public emitEvent(eventAction: string,
                     eventCategory: string,
                     eventValue: string) {
        if (environment.production && isPlatformBrowser(this.platformId) && this.cookiesAccepted) {
            gtag('event',
                eventAction,
                {
                'event_category': eventCategory,
                'event_label': eventValue
                });
        }
    }
}
